let intervalToHandleCommentSection;

function createSubscriptionButton() {
    const subscriptionBtnInComment = document.createElement("button");
    subscriptionBtnInComment.classList.add('font-san', 'mb-[12px]', 'inline-block', 'rounded', 'px-5', 'py-[14px]', 'font-medium', 'leading-none', 'text-white', 'transition-all', 'hover:opacity-90');
    subscriptionBtnInComment.style = "background-color: rgb(92, 90, 159);";
    subscriptionBtnInComment.textContent = "成为会员";
    subscriptionBtnInComment.addEventListener('click', function () {
        window.location.href = "/subscribe";
    });
    return subscriptionBtnInComment;
}

function handleCommentElements() {
    const ghostCommentIframe = document.getElementById("ghost-comments-root").firstChild;
    const commentIframeDocument = ghostCommentIframe.contentDocument || ghostCommentIframe.contentWindow.document;
    if (commentIframeDocument) {
        const signupBtnInComment = commentIframeDocument.querySelector('[data-testid="signup-button"]');
        if (signupBtnInComment) {
            clearInterval(intervalToHandleCommentSection);
            const signupBtnSibling = signupBtnInComment.previousElementSibling;
            const subscriptionBtnInComment = createSubscriptionButton();
            signupBtnSibling.insertAdjacentElement('afterend', subscriptionBtnInComment);
            signupBtnInComment.remove();
        }
    }

}

document.addEventListener('DOMContentLoaded', function() {
    let ghComments = document.querySelectorAll('.gh-comments');
    if (window.location.pathname !== "/" && ghComments.length > 0) {
        intervalToHandleCommentSection = setInterval(handleCommentElements, 200);
    }
});